import { useEffect, useState } from 'react';

import SongQueue, { SongQueueItem } from '~/modules/song-queue/song-queue';

export const useSongQueue = (): readonly SongQueueItem[] => {
  const [queue, setQueue] = useState<readonly SongQueueItem[]>(SongQueue.getQueue);

  useEffect(() => SongQueue.addListener(setQueue), []);

  return queue;
};

/**
 * Where a song sits in the running order, counting from 1, or 0 when it is not queued at all. The
 * place is what the Queue button turns into once pressed, so "already queued" alone is not enough.
 */
export const useQueuePosition = (songId: string | undefined) => {
  const queue = useSongQueue();

  return songId === undefined ? 0 : queue.findIndex((item) => item.song.id === songId) + 1;
};
